import React from 'react';
import { observer } from 'mobx-react-lite';
import { useIntl } from 'react-intl';

import { DefaultIntlFormatValues } from '@ratehub/base-ui';

import COMMON_MESSAGES from '../definitions/Messages';
import CreditCardShape from '../definitions/CreditCardShape';
import FooterDefaultIntlFormatValues from '../definitions/FooterDefaultIntlFormatValues';
import insertAnniversaryBonusColumn from '../functions/insertAnniversaryBonusColumn';
import getInterestAndMinimumIncomeColumns from '../functions/getInterestAndMinimumIncomeColumns';
import CardFooter from './CardFooter';


function CardFooterCashBack({ cardInfo, ...otherProps }) {
    const intl = useIntl();

    const columns = [
        cardInfo.cashBackWelcomeBonus
            ? intl.formatMessage(
                COMMON_MESSAGES.cardFooterCashBackWelcomeBonus,{
                    ...DefaultIntlFormatValues,
                    ...FooterDefaultIntlFormatValues,
                    cashBackWelcomeBonus: cardInfo.cashBackWelcomeBonus,
                })
            : null,

        intl.formatMessage(COMMON_MESSAGES.cardFooterAnnualFee, {
            ...DefaultIntlFormatValues,
            ...FooterDefaultIntlFormatValues,
            ...cardInfo,
            zero: 0,
        }),

        ...getInterestAndMinimumIncomeColumns({
            purchaseInterest: cardInfo.purchaseInterest,
            cashAdvanceInterest: cardInfo.cashAdvanceInterest,
            balanceTransferInterest: cardInfo.balanceTransferInterest,

            minimumIncome: cardInfo.minimumIncome,
            minimumCreditScore: cardInfo.minimumCreditScore,
            intl,
        }),
    ];

    insertAnniversaryBonusColumn({ anniversaryBonus: cardInfo.anniversaryBonus, columns, intl });

    return (
        <CardFooter
            columns={columns}
            {...otherProps}
        />
    );
}

CardFooterCashBack.propTypes = {
    cardInfo: CreditCardShape.isRequired,       //@TODO• inline shapeOf({ cashBackWelcomeBonus: …
};


export default observer(CardFooterCashBack);
